import { render, staticRenderFns } from "./DelSite.vue?vue&type=template&id=2bc1b99e&"
import script from "./DelSite.vue?vue&type=script&lang=js&"
export * from "./DelSite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports